import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Header extends Component {
  render() {
    return <header>{this.props.children}</header>;
  }
}

Header.propTypes = {
  children: PropTypes.any.isRequired,
};
